import React from 'react';
import styled from 'styled-components';

import { TableHead, TableRow, ThItem } from '@/component-style/Table';

const THead = styled(TableHead)`
  min-width: 1480px;
`;

const Th80 = styled(ThItem)`
  width: 80px;
`;

const Th120 = styled(ThItem)`
  width: 120px;
`;

const Th160 = styled(ThItem)`
  width: 160px;
`;

const Th240 = styled(ThItem)`
  width: 240px;
`;

const Header = props => {
  
  return (
    <THead>
      <TableRow>
        <Th120>申請人</Th120>
        <Th120>送審時間</Th120>
        <Th120>工作日期</Th120>
        <Th160>專案代號</Th160>
        <Th160>專案名稱</Th160>
        <Th120>工作項目</Th120>
        <Th120>工作細項</Th120>
        <Th240>起訖時間</Th240>
        <Th80>工時 (分)</Th80>
        <Th80>加班補償</Th80>
        <Th120>核可工時 (分)</Th120>
        <Th80></Th80>
        <Th80></Th80>
      </TableRow>
    </THead>
  );
};

export default Header;
